export const Pokedex: {[speciesid: string]: ModdedSpeciesData} = {
	moltresgalar: {
		inherit: true,
		abilities: {0: "Berserk", H: "Regenerator"},
	},
	zapdosgalar: {
		inherit: true,
		abilities: {0: "Defiant", H: "Intimidate"},
	},
	articunogalar: {
		inherit: true,
		abilities: {0: "Competitive", H: "Magic Bounce"},
	},
	magmortar: {
		inherit: true,
		types: ["Fire", "Fighting"],
		abilities: {0: "Flame Body", 1: "Magma Armor", H: "Neutralizing Gas"},
	},
	magmar: {
		inherit: true,
		abilities: {0: "Flame Body", 1: "Magma Armor", H: "Vital Spirit"},
	},
	magby: {
		inherit: true,
		abilities: {0: "Flame Body", 1: "Magma Armor", H: "Vital Spirit"},
	},
	sandslashalola: {
		inherit: true,
		abilities: {0: "Ice Body", 1: "Prickly Coat", H: "Slush Rush"},
	},
	ninetalesalola: {
		inherit: true,
		abilities: {0: "Snow Cloak", 1: "Ice Body", H: "Snow Warning"},
	},
	volbeat: {
		inherit: true,
		abilities: {0: "Light Power", 1: "Swarm", H: "Prankster"},
	},
	solrock: {
		inherit: true,
		abilities: {0: "Levitate", H: "Light Power"},
	},
	pachirisu: {
		inherit: true,
		abilities: {0: "Light Power", 1: "Pickup", H: "Volt Absorb"},
	},
	lumineon: {
		inherit: true,
		abilities: {0: "Swift Swim", 1: "Storm Drain", H: "Light Power"},
	},
	froslass: {
		inherit: true,
		abilities: {0: "Soul Link", 1: "Ice Body", H: "Merciless"},
	},
	watchog: {
		inherit: true,
		abilities: {0: "Light Power", 1: "Keen Eye", H: "Analytic"},
	},
	simipour: {
		inherit: true,
		abilities: {0: "Gorilla Tactics", 1: "Rain Dish", H: "Torrent"},
	},
	simisear: {
		inherit: true,
		abilities: {0: "Gorilla Tactics", 1: "Optimistic", H: "Blaze"},
	},
	simisage: {
		inherit: true,
		abilities: {0: "Gorilla Tactics", 1: "Rivalry", H: "Overgrow"},
	},
	gigalith: {
		inherit: true,
		abilities: {0: "Sturdy", 1: "Sand Stream", H: "Light Power"},
	},
	jellicent: {
		inherit: true,
		abilities: {0: "Hydration", 1: "Sticky Hold", H: "Merciless"},
	},
	cryogonal: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Vapor Control", H: "Ice Body"},
	},
	gourgeist: {
		inherit: true,
		abilities: {0: "Soul Link", 1: "Frisk", H: "Light Power"},
	},
	gourgeistsmall: {
		inherit: true,
		abilities: {0: "Soul Link", 1: "Frisk", H: "Light Power"},
	},
	gourgeistlarge: {
		inherit: true,
		abilities: {0: "Soul Link", 1: "Frisk", H: "Light Power"},
	},
	gourgeistsuper: {
		inherit: true,
		abilities: {0: "Soul Link", 1: "Frisk", H: "Light Power"},
	},
	crabominable: {
		inherit: true,
		abilities: {0: "Hyper Cutter", 1: "Iron Fist", H: "Ice Body"},
	},
	grapploct: {
		inherit: true,
		abilities: {0: "Limber", 1: "Rain Dish", H: "Technician"},
	},
	polteageist: {
		inherit: true,
		abilities: {0: "Weak Armor", 1: "Rain Dish", H: "Counterfeit"},
	},
	polteageistantique: {
		inherit: true,
		abilities: {0: "Weak Armor", 1: "Rain Dish", H: "Unimpressed"},
	},
	glastrier: {
		inherit: true,
		abilities: {0: "Chilling Neigh", H: "Ice Body"},
	},
	spectrier: {
		inherit: true,
		abilities: {0: "Grim Neigh", H: "Wandering Spirit"},
	},
	rotom: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Wandering Spirit", H: "Unburden"},
	},
	rotomheat: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Counterfeit", H: "Flame Body"},
	},
	rotomwash: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Counterfeit", H: "Water Absorb"},
	},
	rotomfrost: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Counterfeit", H: "Refrigerate"},
	},
	rotomfan: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Counterfeit", H: "Speed Boost"},
	},
	rotommow: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Counterfeit", H: "Grassy Surge"},
	},
	ampharos: {
		inherit: true,
		abilities: {0: "Static", 1: "Plus", H: "Mold Breaker"},
	},
	ampharosmega: {
		inherit: true,
		abilities: {0: "Fluffy"},
	},
	meganium: {
		inherit: true,
		types: ["Grass", "Fairy"],
		abilities: {0: "Overgrow", H: "Flower Veil"},
	},
	garbodor: {
		inherit: true,
		abilities: {0: "Stench", 1: "Sticky Hold", H: "Aftermath"},
	},
	duosion: {
		inherit: true,
		abilities: {0: "Sticky Hold", 1: "Magic Guard", H: "Regenerator"},
	},
	reuniclus: {
		inherit: true,
		abilities: {0: "Sticky Hold", 1: "Magic Guard", H: "Regenerator"},
	},
	deoxys: {
		inherit: true,
		abilities: {0: "Pressure", H: "Sticky Hold"},
	},
	deoxysattack: {
		inherit: true,
		abilities: {0: "Pressure", H: "Sticky Hold"},
	},
	deoxysdefense: {
		inherit: true,
		abilities: {0: "Pressure", H: "Sticky Hold"},
	},
	deoxysspeed: {
		inherit: true,
		abilities: {0: "Pressure", H: "Sticky Hold"},
	},
	umbreon: {
		inherit: true,
		abilities: {0: "Corrosion", 1: "Merciless", H: "Power of Alchemy (Umbreon)"},
	},
	alcremie: {
		inherit: true,
		abilities: {0: "Sweet Veil", 1: "Sticky Hold", H: "Power of Alchemy (Alcremie)"},
	},
	milcery: {
		inherit: true,
		abilities: {0: "Sweet Veil", 1: "Sticky Hold", H: "Aroma Veil"},
	},
	mantine: {
		inherit: true,
		abilities: {0: "Swift Swim", 1: "Hydration", H: "Sticky Hold"},
	},
	melmetal: {
		inherit: true,
		abilities: {0: "Iron Fist", H: "Sticky Hold"},
	},
	mesprit: {
		inherit: true,
		types: ["Psychic", "Fairy"],
		abilities: {0: "Levitate", 1: "Moody", H: "Prankster"},
	},
	azelf: {
		inherit: true,
		types: ["Psychic", "Fighting"],
		abilities: {0: "Levitate", 1: "Competitive", H: "Moxie"},
	},
	dartrix: {
		inherit: true,
		abilities: {0: "Overgrow", H: "Moody"},
	},
	decidueye: {
		inherit: true,
		abilities: {0: "Overgrow", H: "Moody"},
	},
	steenee: {
		inherit: true,
		abilities: {0: "Leaf Guard", 1: "Moody", H: "Sweet Veil"},
	},
	malamar: {
		inherit: true,
		abilities: {0: "Contrary", 1: "Suction Cups", H: "Moody"},
	},
	hypno: {
		inherit: true,
		abilities: {0: "Insomnia", 1: "Forewarn", H: "Moody"},
	},
	spinda: {
		inherit: true,
		abilities: {0: "Moody", 1: "Tangled Feet", H: "Contrary"},
	},
	passimian: {
		inherit: true,
		abilities: {0: "Receiver", 1: "Libero", H: "Defiant"},
	},
	electrode: {
		inherit: true,
		abilities: {0: "Libero", 1: "Counterfeit", H: "Aftermath"},
	},
	dubwool: {
		inherit: true,
		abilities: {0: "Fluffy", 1: "Libero", H: "Bulletproof"},
	},
	jumpluff: {
		inherit: true,
		abilities: {0: "Leaf Guard", 1: "Libero", H: "Infiltrator"},
	},
	lucario: {
		inherit: true,
		abilities: {0: "Libero", 1: "Inner Focus", H: "Rivalry"},
	},
	wigglytuff: {
		inherit: true,
		abilities: {0: "Cute Charm", 1: "Competitive", H: "Libero"},
	},
	electivire: {
		inherit: true,
		types: ["Electric", "Dark"],
		abilities: {0: "Motor Drive", 1: "Libero", H: "Iron Fist"},
	},
	eevee: {
		inherit: true,
		abilities: {0: "Run Away", 1: "Adaptability", H: "Libero"},
	},
	plusle: {
		inherit: true,
		abilities: {0: "Plus", 1: "Libero", H: "Lightning Rod"},
	},
	minun: {
		inherit: true,
		abilities: {0: "Minus", 1: "Libero", H: "Volt Absorb"},
	},
	cacnea: {
		inherit: true,
		abilities: {0: "Sand Veil", 1: "Water Compaction", H: "Water Absorb"},
	},
	cacturne: {
		inherit: true,
		abilities: {0: "Wandering Spirit", 1: "Water Compaction", H: "Prickly Coat"},
	},
	lileep: {
		inherit: true,
		abilities: {0: "Suction Cups", 1: "Water Compaction", H: "Storm Drain"},
	},
	cradily: {
		inherit: true,
		abilities: {0: "Suction Cups", 1: "Water Compaction", H: "Storm Drain"},
	},
	stunfisk: {
		inherit: true,
		abilities: {0: "Static", 1: "Water Compaction", H: "Sand Veil"},
	},
	phanpy: {
		inherit: true,
		abilities: {0: "Pickup", 1: "Water Compaction", H: "Sand Veil"},
	},
	donphan: {
		inherit: true,
		abilities: {0: "Sturdy", 1: "Water Compaction", H: "Sand Veil"},
	},
	muk: {
		inherit: true,
		abilities: {0: "Regenerator", 1: "Sticky Hold", H: "Poison Touch"},
	},
	mukalola: {
		inherit: true,
		abilities: {0: "Poison Touch", 1: "Scavenge", H: "Power of Alchemy (Muk-Alola)"},
	},
	mismagius: {
		inherit: true,
		types: ["Ghost", "Fairy"],
		abilities: {0: "Levitate", 1: "Power of Alchemy (Mismagius)", H: "Corrosion"},
	},
	samurott: {
		inherit: true,
		types: ["Water", "Fighting"],
		abilities: {0: "Torrent", H: "Shell Armor"},
	},
	dewott: {
		inherit: true,
		types: ["Water", "Fighting"],
		abilities: {0: "Torrent", H: "No Guard"},
	},
	oshawott: {
		inherit: true,
		abilities: {0: "Torrent", H: "No Guard"},
	},
	buzzwole: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Iron Fist"},
	},
	metagross: {
		inherit: true,
		abilities: {0: "Clear Body", 1: "Iron Fist", H: "Neuroforce"},
	},
	metang: {
		inherit: true,
		abilities: {0: "Clear Body", 1: "Iron Fist", H: "Neuroforce"},
	},
	metagrossmega: {
		inherit: true,
		abilities: {0: "Neuroforce"},
	},
	poliwrath: {
		inherit: true,
		abilities: {0: "Water Absorb", 1: "Iron Fist", H: "Swift Swim"},
	},
	toxicroak: {
		inherit: true,
		abilities: {0: "Iron Fist", 1: "Dry Skin", H: "Poison Touch"},
	},
	lucariomega: {
		inherit: true,
		abilities: {0: "Iron Fist"},
	},
	zebstrika: {
		inherit: true,
		abilities: {0: "Overclock", 1: "Motor Drive", H: "Sap Sipper"},
	},
	manectric: {
		inherit: true,
		abilities: {0: "Static", 1: "Lightning Rod", H: "Overclock"},
	},
	celebi: {
		inherit: true,
		abilities: {0: "Natural Cure", H: "Overclock"},
	},
	braviary: {
		inherit: true,
		abilities: {0: "Optimistic", 1: "Sheer Force", H: "Defiant"},
	},
	haxorus: {
		inherit: true,
		abilities: {0: "Overclock", 1: "Mold Breaker", H: "Rivalry"},
	},
	duraludon: {
		inherit: true,
		abilities: {0: "Light Metal", 1: "Heavy Metal", H: "Overclock"},
	},
	hydreigon: {
		inherit: true,
		abilities: {0: "Levitate", H: "Overclock"},
	},
	gallademega: {
		inherit: true,
		abilities: {0: "Overclock"},
	},
	exeggutoralola: {
		inherit: true,
		abilities: {0: "Frisk", 1: "Optimistic", H: "Harvest"},
	},
	infernape: {
		inherit: true,
		abilities: {0: "Blaze", H: "Overclock"},
	},
	blazikenmega: {
		inherit: true,
		abilities: {0: "Overclock"},
	},
	magearna: {
		inherit: true,
		abilities: {0: "Soul-Heart", H: "Overclock"},
	},
	magearnaoriginal: {
		inherit: true,
		abilities: {0: "Soul-Heart", H: "Overclock"},
	},
	dialga: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Overclock", H: "Telepathy"},
	},
	slowbromega: {
		inherit: true,
		abilities: {0: "Prickly Coat"},
	},
	omastar: {
		inherit: true,
		abilities: {0: "Swift Swim", 1: "Prickly Coat", H: "Weak Armor"},
	},
	corsolagalar: {
		inherit: true,
		abilities: {0: "Weak Armor", 1: "Prickly Coat", H: "Cursed Body"},
	},
	cursola: {
		inherit: true,
		abilities: {0: "Weak Armor", 1: "Prickly Coat", H: "Perish Body"},
	},
	corsola: {
		inherit: true,
		abilities: {0: "Prickly Coat", 1: "Natural Cure", H: "Regenerator"},
	},
	qwilfish: {
		inherit: true,
		abilities: {0: "Prickly Coat", 1: "Swift Swim", H: "Intimidate"},
	},
	roselia: {
		inherit: true,
		abilities: {0: "Natural Cure", 1: "Prickly Coat", H: "Leaf Guard"},
	},
	roserade: {
		inherit: true,
		abilities: {0: "Natural Cure", 1: "Prickly Coat", H: "Technician"},
	},
	maractus: {
		inherit: true,
		abilities: {0: "Prickly Coat", 1: "Chlorophyll", H: "Storm Drain"},
	},
	chesnaught: {
		inherit: true,
		abilities: {0: "Overgrow", H: "Prickly Coat"},
	},
	sandslash: {
		inherit: true,
		abilities: {0: "Sand Veil", 1: "Prickly Coat", H: "Sand Rush"},
	},
	pincurchin: {
		inherit: true,
		abilities: {0: "Lightning Rod", 1: "Prickly Coat", H: "Electric Surge"},
	},
	jolteon: {
		inherit: true,
		abilities: {0: "Volt Absorb", 1: "Prickly Coat", H: "Power of Alchemy (Jolteon)"},
	},
	toxapex: {
		inherit: true,
		abilities: {0: "Merciless", 1: "Prickly Coat", H: "Regenerator"},
	},
	poipole: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Prickly Coat"},
	},
	naganadel: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Prickly Coat"},
	},
	bastiodon: {
		inherit: true,
		abilities: {0: "Sturdy", 1: "Sand Veil", H: "Soundproof"},
	},
	regirock: {
		inherit: true,
		abilities: {0: "Clear Body", 1: "Sand Veil", H: "Sturdy"},
	},
	vibrava: {
		inherit: true,
		abilities: {0: "Levitate", H: "Sand Veil"},
	},
	flygon: {
		inherit: true,
		abilities: {0: "Levitate", H: "Sand Veil"},
	},
	sandile: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Moxie", H: "Sand Veil"},
	},
	krokorok: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Moxie", H: "Sand Veil"},
	},
	krookodile: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Moxie", H: "Concussion"},
	},
	weezing: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Neutralizing Gas", H: "Power of Alchemy (Weezing)"},
	},
	weezinggalar: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Neutralizing Gas", H: "Power of Alchemy (Weezing)"},
	},
	slowkinggalar: {
		inherit: true,
		abilities: {0: "Curious Medicine", 1: "Power of Alchemy (Slowking-Galar)", H: "Regenerator"},
	},
	ditto: {
		inherit: true,
		abilities: {0: "Limber", 1: "Power of Alchemy (Ditto)", H: "Imposter"},
	},
	vanillite: {
		inherit: true,
		abilities: {0: "Ice Body", 1: "Snow Cloak", H: "Power of Alchemy (Vanillite)"},
	},
	vanillish: {
		inherit: true,
		abilities: {0: "Ice Body", 1: "Snow Cloak", H: "Power of Alchemy (Vanillite)"},
	},
	vanilluxe: {
		inherit: true,
		abilities: {0: "Ice Body", 1: "Snow Warning", H: "Power of Alchemy (Vanilluxe)"},
	},
	cyndaquil: {
		inherit: true,
		abilities: {0: "Blaze", H: "Magma Armor"},
	},
	quilava: {
		inherit: true,
		abilities: {0: "Blaze", H: "Magma Armor"},
	},
	typhlosion: {
		inherit: true,
		types: ["Fire", "Ground"],
		abilities: {0: "Blaze", H: "Neuroforce"},
	},
	feraligatr: {
		inherit: true,
		types: ["Water", "Dark"],
	},
	centiskorch: {
		inherit: true,
		abilities: {0: "Flash Fire", 1: "Intimidate", H: "Sticky Hold"},
	},
	houndoom: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Flash Fire", H: "Solar Power"},
	},
	houndoommega: {
		inherit: true,
		abilities: {0: "Sheer Force"},
	},
	blacephalon: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Regenerator"},
	},
	chandelure: {
		inherit: true,
		abilities: {0: "Flash Fire", 1: "Merciless", H: "Infiltrator"},
	},
	salazzle: {
		inherit: true,
		abilities: {0: "Corrosion", 1: "Merciless", H: "Oblivious"},
	},
	skorupi: {
		inherit: true,
		abilities: {0: "Buzz Off", 1: "Sniper", H: "Keen Eye"},
	},
	drapion: {
		inherit: true,
		abilities: {0: "Buzz Off", 1: "Sniper", H: "Merciless"},
	},
	trevenant: {
		inherit: true,
		abilities: {0: "Leaf Guard", 1: "Merciless", H: "Harvest"},
	},
	skuntank: {
		inherit: true,
		abilities: {0: "Neutralizing Gas", 1: "Aftermath", H: "Merciless"},
	},
	seviper: {
		inherit: true,
		abilities: {0: "Rivalry", 1: "Merciless", H: "Infiltrator"},
	},
	zangoose: {
		inherit: true,
		abilities: {0: "Rivalry", 1: "Immunity", H: "Toxic Boost"},
	},
	honchkrow: {
		inherit: true,
		abilities: {0: "Counterfeit", 1: "Merciless", H: "Moxie"},
	},
	smeargle: {
		inherit: true,
		abilities: {0: "Pastel Veil", 1: "Technician", H: "Moody"},
	},
	florges: {
		inherit: true,
		abilities: {0: "Flower Veil", 1: "Pastel Veil", H: "Symbiosis"},
	},
	sylveon: {
		inherit: true,
		abilities: {0: "Natural Cure", 1: "Pixilate", H: "Power of Alchemy (Sylveon)"},
	},
	vivillon: {
		inherit: true,
		abilities: {0: "Pastel Veil", 1: "Compound Eyes", H: "Friend Guard"},
	},
	bruxish: {
		inherit: true,
		abilities: {0: "Dazzling", 1: "Strong Jaw", H: "Pastel Veil"},
	},
	milotic: {
		inherit: true,
		abilities: {0: "Marvel Scale", 1: "Competitive", H: "Pastel Veil"},
	},
	kecleon: {
		inherit: true,
		abilities: {0: "Color Change", 1: "Pastel Veil", H: "Protean"},
	},
	aromatisse: {
		inherit: true,
		abilities: {0: "Unimpressed", 1: "Pastel Veil", H: "Aroma Veil"},
	},
	lilligant: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Optimistic", H: "Pastel Veil"},
	},
	calyrex: {
		inherit: true,
		abilities: {0: "Unnerve", H: "Neuroforce"},
	},
	uxie: {
		inherit: true,
		types: ["Psychic", "Steel"],
		abilities: {0: "Levitate", 1: "Neuroforce", H: "Filter"},
	},
	necrozma: {
		inherit: true,
		abilities: {0: "Prism Armor", H: "Neuroforce"},
	},
	lapras: {
		inherit: true,
		abilities: {0: "Water Absorb", 1: "Neuroforce", H: "Hydration"},
	},
	psyduck: {
		inherit: true,
		abilities: {0: "Neuroforce", 1: "Cloud Nine", H: "Swift Swim"},
	},
	golduck: {
		inherit: true,
		abilities: {0: "Neuroforce", 1: "Vapor Control", H: "Swift Swim"},
	},
	nihilego: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Neuroforce"},
	},
	chatot: {
		inherit: true,
		abilities: {0: "Keen Eye", 1: "Tangled Feet", H: "Neuroforce"},
	},
	wishiwashischool: {
		inherit: true,
		types: ["Water", "Dragon"],
	},
	paras: {
		inherit: true,
		abilities: {0: "Effect Spore", 1: "Dry Skin", H: "Buzz Off"},
	},
	parasect: {
		inherit: true,
		abilities: {0: "Effect Spore", 1: "Hydration", H: "Buzz Off"},
	},
	spinarak: {
		inherit: true,
		abilities: {0: "Buzz Off", 1: "Insomnia", H: "Sniper"},
	},
	ariados: {
		inherit: true,
		abilities: {0: "Buzz Off", 1: "Merciless", H: "Sniper"},
	},
	combee: {
		inherit: true,
		abilities: {0: "Honey Gather", 1: "Buzz Off", H: "Hustle"},
	},
	vespiquen: {
		inherit: true,
		abilities: {0: "Parental Bond", 1: "Buzz Off", H: "Honey Gather"},
	},
	sewaddle: {
		inherit: true,
		abilities: {0: "Swarm", 1: "Chlorophyll", H: "Buzz Off"},
	},
	swadloon: {
		inherit: true,
		abilities: {0: "Swarm", 1: "Chlorophyll", H: "Buzz Off"},
	},
	leavanny: {
		inherit: true,
		abilities: {0: "Parental Bond", 1: "Leaf Guard", H: "Buzz Off"},
	},
	joltik: {
		inherit: true,
		abilities: {0: "Compound Eyes", 1: "Unnerve", H: "Swarm"},
	},
	galvantula: {
		inherit: true,
		abilities: {0: "Compound Eyes", 1: "Unnerve", H: "Swarm"},
	},
	pheromosa: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Buzz Off"},
	},
	vikavolt: {
		inherit: true,
		abilities: {0: "Levitate", H: "Scavenge"},
	},
	starmie: {
		inherit: true,
		abilities: {0: "Gravitation", 1: "Natural Cure", H: "Analytic"},
	},
	forretress: {
		inherit: true,
		abilities: {0: "Sturdy", 1: "Gravitation", H: "Overcoat"},
	},
	steelixmega: {
		inherit: true,
		abilities: {0: "Gravitation"},
	},
	baltoy: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Gravitation", H: "Water Compaction"},
	},
	claydol: {
		inherit: true,
		abilities: {0: "Levitate", 1: "Gravitation", H: "Water Compaction"},
	},
	torterra: {
		inherit: true,
		abilities: {0: "Overgrow", H: "Gravitation"},
	},
	cresselia: {
		inherit: true,
		types: ["Psychic", "Fairy"],
		abilities: {0: "Levitate", 1: "Cloud Nine", H: "Gravitation"},
	},
	giratina: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Gravitation", H: "Telepathy"},
	},
	elgyem: {
		inherit: true,
		abilities: {0: "Gravitation", 1: "Synchronize", H: "Analytic"},
	},
	beheeyem: {
		inherit: true,
		abilities: {0: "Gravitation", 1: "Synchronize", H: "Analytic"},
	},
	orbeetle: {
		inherit: true,
		abilities: {0: "Swarm", 1: "Frisk", H: "Gravitation"},
	},
	stonjourner: {
		inherit: true,
		abilities: {0: "Power Spot", H: "Gravitation"},
	},
	rhyhorn: {
		inherit: true,
		abilities: {0: "Lightning Rod", 1: "Rock Head", H: "Magma Armor"},
	},
	rhydon: {
		inherit: true,
		abilities: {0: "Lightning Rod", 1: "Rock Head", H: "Magma Armor"},
	},
	rhyperior: {
		inherit: true,
		abilities: {0: "Lightning Rod", 1: "Solid Rock", H: "Magma Armor"},
	},
	diglettalola: {
		inherit: true,
		abilities: {0: "Magma Armor", 1: "Tangling Hair", H: "Sand Force"},
	},
	dugtrioalola: {
		inherit: true,
		abilities: {0: "Magma Armor", 1: "Tangling Hair", H: "Sand Force"},
	},
	turtonator: {
		inherit: true,
		abilities: {0: "Shell Armor", 1: "Optimistic", H: "Magma Armor"},
	},
	entei: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Magma Armor", H: "Inner Focus"},
	},
	suicune: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Hydration", H: "Inner Focus"},
	},
	torkoal: {
		inherit: true,
		abilities: {0: "White Smoke", 1: "Drought", H: "Magma Armor"},
	},
	crustle: {
		inherit: true,
		abilities: {0: "Sturdy", 1: "Magma Armor", H: "Weak Armor"},
	},
	archeops: {
		inherit: true,
		abilities: {0: "Defeatist", H: "Early Bird"},
	},
	celesteela: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Flare Boost"},
	},
	zarude: {
		inherit: true,
		abilities: {0: "Natural Cure", H: "Leaf Guard"},
	},
	zarudedada: {
		inherit: true,
		abilities: {0: "Parental Bond", H: "Leaf Guard"},
	},
	shiftry: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Leaf Guard", H: "Optimistic"},
	},
	appletun: {
		inherit: true,
		abilities: {0: "Ripen", 1: "Leaf Guard", H: "Thick Fat"},
	},
	tropius: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Leaf Guard", H: "Harvest"},
	},
	exeggutor: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Leaf Guard", H: "Harvest"},
	},
	virizion: {
		inherit: true,
		abilities: {0: "Justified", H: "Leaf Guard"},
	},
	shayminsky: {
		inherit: true,
		abilities: {0: "Leaf Guard"},
	},
	victreebel: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Leaf Guard", H: "Gluttony"},
	},
	sirfetchd: {
		inherit: true,
		abilities: {0: "Steadfast", 1: "Leaf Guard", H: "Scrappy"},
	},
	banette: {
		inherit: true,
		abilities: {0: "Insomnia", 1: "Soul Link", H: "Cursed Body"},
	},
	spiritomb: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Soul Link", H: "Wandering Spirit"},
	},
	hoopa: {
		inherit: true,
		abilities: {0: "Magician", H: "Wandering Spirit"},
	},
	hoopaunbound: {
		inherit: true,
		abilities: {0: "Magician", H: "Soul Link"},
	},
	honedge: {
		inherit: true,
		abilities: {0: "No Guard", 1: "Rivalry", H: "Soul Link"},
	},
	doublade: {
		inherit: true,
		abilities: {0: "No Guard", 1: "Rivalry", H: "Soul Link"},
	},
	dusclops: {
		inherit: true,
		types: ["Ghost", "Fighting"],
		abilities: {0: "Pressure", 1: "Soul Link", H: "Iron Fist"},
	},
	dusknoir: {
		inherit: true,
		types: ["Ghost", "Fighting"],
		abilities: {0: "Pressure", 1: "Soul Link", H: "Iron Fist"},
	},
	gardevoir: {
		inherit: true,
		abilities: {0: "Synchronize", 1: "Trace", H: "Soul Link"},
	},
	marowakalola: {
		inherit: true,
		abilities: {0: "Soul Link", 1: "Lightning Rod", H: "Rock Head"},
	},
	marowak: {
		inherit: true,
		abilities: {0: "Wandering Spirit", 1: "Lightning Rod", H: "Battle Armor"},
	},
	cofagrigus: {
		inherit: true,
		abilities: {0: "Mummy", H: "Wandering Spirit"},
	},
	goodra: {
		inherit: true,
		types: ["Dragon", "Poison"],
		abilities: {0: "Sticky Hold", 1: "Neuroforce", H: "Gooey"},
	},
	sliggoo: {
		inherit: true,
		types: ["Dragon", "Poison"],
		abilities: {0: "Sticky Hold", 1: "Hydration", H: "Gooey"},
	},
	dodrio: {
		inherit: true,
		types: ["Ground", "Flying"],
		abilities: {0: "Analytic", 1: "Early Bird", H: "Moody"},
	},
	beedrillmega: {
		inherit: true,
		types: ["Bug", "Ground"],
		abilities: {0: "Adaptability"},
	},
	heracross: {
		inherit: true,
		abilities: {0: "Honey Gather", 1: "Guts", H: "Moxie"},
	},
	beautifly: {
		inherit: true,
		abilities: {0: "Swarm", 1: "Honey Gather", H: "Rivalry"},
	},
	dustox: {
		inherit: true,
		abilities: {0: "Shield Dust", 1: "Honey Gather", H: "Compound Eyes"},
	},
	cherubi: {
		inherit: true,
		abilities: {0: "Chlorophyll", H: "Honey Gather"},
	},
	snorlax: {
		inherit: true,
		abilities: {0: "Honey Gather", 1: "Thick Fat", H: "Gluttony"},
	},
	ursaring: {
		inherit: true,
		abilities: {0: "Guts", 1: "Quick Feet", H: "Honey Gather"},
	},
	surskit: {
		inherit: true,
		abilities: {0: "Swift Swim", 1: "Honey Gather", H: "Rain Dish"},
	},
	masquerain: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Honey Gather", H: "Unnerve"},
	},
	burmy: {
		inherit: true,
		abilities: {0: "Shed Skin", 1: "Honey Gather", H: "Overcoat"},
	},
	wormadam: {
		inherit: true,
		abilities: {0: "Simple", 1: "Honey Gather", H: "Overcoat"},
	},
	wormadamsandy: {
		inherit: true,
		abilities: {0: "Fur Coat", 1: "Honey Gather", H: "Overcoat"},
	},
	wormadamtrash: {
		inherit: true,
		abilities: {0: "Thick Fat", 1: "Honey Gather", H: "Overcoat"},
	},
	mothim: {
		inherit: true,
		abilities: {0: "Swarm", 1: "Honey Gather", H: "Tinted Lens"},
	},
	armaldo: {
		inherit: true,
		abilities: {0: "Battle Armor", 1: "Hydration", H: "Swift Swim"},
	},
	politoed: {
		inherit: true,
		abilities: {0: "Hydration", 1: "Damp", H: "Drizzle"},
	},
	kangaskhan: {
		inherit: true,
		abilities: {0: "Early Bird", 1: "Scrappy", H: "Parental Bond"},
	},
	eelektross: {
		inherit: true,
		types: ["Electric", "Poison"],
		abilities: {0: "Levitate", 1: "Neuroforce", H: "Swift Swim"},
	},
	audinomega: {
		inherit: true,
		abilities: {0: "Fairy Aura"},
	},
	guzzlord: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Honey Gather"},
	},
	breloom: {
		inherit: true,
		abilities: {0: "Toxic Boost", 1: "Technician", H: "Poison Heal"},
	},
	hariyama: {
		inherit: true,
		abilities: {0: "Thick Fat", 1: "Toxic Boost", H: "Sheer Force"},
	},
	gligar: {
		inherit: true,
		abilities: {0: "Hyper Cutter", 1: "Sand Veil", H: "Toxic Boost"},
	},
	seismitoad: {
		inherit: true,
		abilities: {0: "Swift Swim", 1: "Toxic Boost", H: "Water Absorb"},
	},
	heliolisk: {
		inherit: true,
		abilities: {0: "Dry Skin", 1: "Flare Boost", H: "Solar Power"},
	},
	sunflora: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Optimistic", H: "Flare Boost"},
	},
	darmanitan: {
		inherit: true,
		abilities: {0: "Sheer Force", 1: "Gorilla Tactics", H: "Zen Mode"},
	},
	darmanitanzen: {
		inherit: true,
		abilities: {0: "Sheer Force", 1: "Gorilla Tactics", H: "Zen Mode"},
	},
	primeape: {
		inherit: true,
		abilities: {0: "Vital Spirit", 1: "Gorilla Tactics", H: "Defiant"},
	},
	oranguru: {
		inherit: true,
		abilities: {0: "Inner Focus", 1: "Gorilla Tactics", H: "Symbiosis"},
	},
	bewear: {
		inherit: true,
		abilities: {0: "Fluffy", 1: "Concussion", H: "Unnerve"},
	},
	terrakion: {
		inherit: true,
		abilities: {0: "Justified", H: "Concussion"},
	},
	pangoro: {
		inherit: true,
		abilities: {0: "Iron Fist", 1: "Concussion", H: "Scrappy"},
	},
	scrafty: {
		inherit: true,
		abilities: {0: "Shed Skin", 1: "Moxie", H: "Concussion"},
	},
	eternatus: {
		inherit: true,
		abilities: {0: "Pressure", H: "Concussion"},
	},
	swoobat: {
		inherit: true,
		abilities: {0: "Concussion", 1: "Klutz", H: "Simple"},
	},
	druddigon: {
		inherit: true,
		abilities: {0: "Rough Skin", 1: "Sheer Force", H: "Concussion"},
	},
	victini: {
		inherit: true,
		abilities: {0: "Victory Star", H: "Neuroforce"},
	},
	garchompmega: {
		inherit: true,
		abilities: {0: "Neuroforce"},
	},
	raikou: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Neuroforce", H: "Inner Focus"},
	},
	banettemega: {
		inherit: true,
		types: ["Ghost", "Steel"],
		abilities: {0: "Counterfeit"},
	},
	silvally: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	typenull: {
		inherit: true,
		abilities: {0: "Battle Armor", 1: "Pressure", H: "Power of Alchemy (Type: Null)"},
	},
	gyaradosmega: {
		inherit: true,
		abilities: {0: "Rain Dish"},
	},
	amoonguss: {
		inherit: true,
		abilities: {0: "Effect Spore", 1: "Counterfeit", H: "Regenerator"},
	},
	klefki: {
		inherit: true,
		abilities: {0: "Prankster", 1: "Counterfeit", H: "Magician"},
	},
	liepard: {
		inherit: true,
		abilities: {0: "Counterfeit", 1: "Unburden", H: "Prankster"},
	},
	stunfiskgalar: {
		inherit: true,
		abilities: {0: "Mimicry", H: "Counterfeit"},
	},
	sudowoodo: {
		inherit: true,
		abilities: {0: "Counterfeit", 1: "Rock Head", H: "Rattled"},
	},
	grimmsnarl: {
		inherit: true,
		abilities: {0: "Prankster", 1: "Counterfeit", H: "Pickpocket"},
	},
	absol: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Super Luck", H: "Justified"},
	},
	luxray: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Intimidate", H: "Guts"},
	},
	mandibuzz: {
		inherit: true,
		abilities: {0: "Big Pecks", 1: "Overcoat", H: "Scavenge"},
	},
	mightyena: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Quick Feet", H: "Scavenge"},
	},
	purugly: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Unimpressed", H: "Defiant"},
	},
	raticate: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Guts", H: "Hustle"},
	},
	raticatealola: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Hustle", H: "Thick Fat"},
	},
	staraptor: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Scavenge", H: "Reckless"},
	},
	remoraid: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Sniper", H: "Moody"},
	},
	octillery: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Sniper", H: "Moody"},
	},
	sneasel: {
		inherit: true,
		abilities: {0: "Inner Focus", 1: "Keen Eye", H: "Snow Cloak"},
	},
	weavile: {
		inherit: true,
		abilities: {0: "Pressure", 1: "Pickpocket", H: "Snow Cloak"},
	},
	linoone: {
		inherit: true,
		abilities: {0: "Scavenge", 1: "Gluttony", H: "Quick Feet"},
	},
	whiscash: {
		inherit: true,
		abilities: {0: "Unimpressed", 1: "Anticipation", H: "Hydration"},
	},
	vileplume: {
		inherit: true,
		abilities: {0: "Chlorophyll", 1: "Unimpressed", H: "Effect Spore"},
	},
	empoleon: {
		inherit: true,
		abilities: {0: "Torrent", H: "Competitive"},
	},
	espurr: {
		inherit: true,
		abilities: {0: "Keen Eye", 1: "Infiltrator", H: "Unimpressed"},
	},
	tsareena: {
		inherit: true,
		abilities: {0: "Leaf Guard", 1: "Queenly Majesty", H: "Unimpressed"},
	},
	wailord: {
		inherit: true,
		abilities: {0: "Water Veil", 1: "Unimpressed", H: "Pressure"},
	},
	mudsdale: {
		inherit: true,
		abilities: {0: "Unimpressed", 1: "Stamina", H: "Inner Focus"},
	},
	cobalion: {
		inherit: true,
		abilities: {0: "Justified", H: "Unimpressed"},
	},
	lickilicky: {
		inherit: true,
		abilities: {0: "Unimpressed", 1: "Oblivious", H: "Cloud Nine"},
	},
	musharna: {
		inherit: true,
		abilities: {0: "Forewarn", 1: "Synchronize", H: "Unimpressed"},
	},
	vaporeon: {
		inherit: true,
		abilities: {0: "Water Absorb", 1: "Hydration", H: "Power of Alchemy (Vaporeon)"},
	},
	flareon: {
		inherit: true,
		abilities: {0: "Flash Fire", 1: "Fluffy", H: "Power of Alchemy (Flareon)"},
	},
	espeon: {
		inherit: true,
		abilities: {0: "Analytic", 1: "Magic Bounce", H: "Power of Alchemy (Espeon)"},
	},
	leafeon: {
		inherit: true,
		abilities: {0: "Leaf Guard", 1: "Chlorophyll", H: "Power of Alchemy (Leafeon)"},
	},
	glaceon: {
		inherit: true,
		abilities: {0: "Snow Cloak", 1: "Snow Warning", H: "Power of Alchemy (Glaceon)"},
	},
	keldeo: {
		inherit: true,
		abilities: {0: "Justified", H: "Vapor Control"},
	},
	keldeoresolute: {
		inherit: true,
		abilities: {0: "Justified", H: "Vapor Control"},
	},
	gastrodon: {
		inherit: true,
		abilities: {0: "Sticky Hold", 1: "Storm Drain", H: "Vapor Control"},
	},
	swanna: {
		inherit: true,
		abilities: {0: "Vapor Control", 1: "Big Pecks", H: "Hydration"},
	},
	volcanion: {
		inherit: true,
		abilities: {0: "Water Absorb", H: "Vapor Control"},
	},
	walrein: {
		inherit: true,
		abilities: {0: "Thick Fat", 1: "Ice Body", H: "Vapor Control"},
	},
	floatzel: {
		inherit: true,
		abilities: {0: "Swift Swim", 1: "Vapor Control", H: "Water Veil"},
	},
	cloyster: {
		inherit: true,
		abilities: {0: "Vapor Control", 1: "Skill Link", H: "Overcoat"},
	},
	pyroar: {
		inherit: true,
		abilities: {0: "Rivalry", 1: "Optimistic", H: "Moxie"},
	},
	crobat: {
		inherit: true,
		abilities: {0: "Inner Focus", 1: "Optimistic", H: "Infiltrator"},
	},
	noivern: {
		inherit: true,
		abilities: {0: "Frisk", 1: "Optimistic", H: "Scavenge"},
	},
	meloetta: {
		inherit: true,
		abilities: {0: "Serene Grace", H: "Optimistic"},
	},
	meloettapirouette: {
		inherit: true,
		abilities: {0: "Serene Grace", H: "Optimistic"},
	},
	sceptilemega: {
		inherit: true,
		abilities: {0: "Optimistic"},
	},
	kartana: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Light Power"},
	},
	salamence: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Rivalry", H: "Moxie"},
	},
	girafarig: {
		inherit: true,
		abilities: {0: "Inner Focus", 1: "Rivalry", H: "Sap Sipper"},
	},
	fearow: {
		inherit: true,
		abilities: {0: "Keen Eye", 1: "Rivalry", H: "Sniper"},
	},
	tauros: {
		inherit: true,
		abilities: {0: "Intimidate", 1: "Rivalry", H: "Sheer Force"},
	},
	basculin: {
		inherit: true,
		abilities: {0: "Reckless", 1: "Adaptability", H: "Rivalry"},
	},
	basculinbluestriped: {
		inherit: true,
		abilities: {0: "Rock Head", 1: "Adaptability", H: "Rivalry"},
	},
	arctovish: {
		inherit: true,
		abilities: {0: "Water Absorb", 1: "Snow Cloak", H: "Slush Rush"},
	},
	darmanitangalar: {
		inherit: true,
		abilities: {0: "Gorilla Tactics", 1: "Snow Cloak", H: "Zen Mode"},
	},
	darmanitangalarzen: {
		inherit: true,
		abilities: {0: "Gorilla Tactics", 1: "Snow Cloak", H: "Zen Mode"},
	},
	xurkitree: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Counterfeit"},
	},
	stakataka: {
		inherit: true,
		abilities: {0: "Beast Boost", H: "Sand Veil"},
	},
	diancie: {
		inherit: true,
		abilities: {0: "Clear Body", H: "Sand Veil"},
	},
	carbink: {
		inherit: true,
		abilities: {0: "Clear Body", 1: "Sturdy", H: "Sand Veil"},
	},
	shuckle: {
		inherit: true,
		abilities: {0: "Sturdy", 1: "Sand Veil", H: "Contrary"},
	},
	// silvally moment
	silvallybug: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallydark: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallydragon: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyelectric: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyfairy: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyfighting: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyfire: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyflying: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyghost: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallygrass: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyground: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyice: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallypoison: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallypsychic: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallyrock: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallysteel: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
	silvallywater: {
		inherit: true,
		abilities: {0: "RKS System", 1: "Download", H: "Power of Alchemy (Silvally)"},
	},
};
